module.exports = __webpack_public_path__ + "static/why-hexomatic-lg-1d5baae8cabce45764397db068698eaa.png";